import { cloneDeep } from "lodash";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { IPaymentMethodItem } from "web/types/Payment";

const mergePaymentMethods = (
  accumulated: IPaymentMethodItem[],
  incoming: IPaymentMethodItem[]
): IPaymentMethodItem[] => {
  const clonedIncoming = isArrayHasItems(incoming) ? cloneDeep(incoming) : [];

  if (!isArrayHasItems(accumulated)) {
    return clonedIncoming;
  }

  return accumulated.map((paymentItem, paymentItemIndex) => {
    const incomingItem = clonedIncoming[paymentItemIndex];

    if (!incomingItem) {
      return cloneDeep(paymentItem);
    }

    const mergedValues = paymentItem.values.map((paymentValue) => {
      const matchingIncoming = incomingItem.values.find(
        ({ name }) => name === paymentValue.name
      );

      if (!matchingIncoming) {
        return { ...paymentValue };
      }

      return {
        ...paymentValue,
        value: +paymentValue.value + +matchingIncoming.value,
      };
    });

    incomingItem.values.forEach((incomingValue) => {
      const alreadyMerged = mergedValues.some(
        ({ name }) => name === incomingValue.name
      );

      if (!alreadyMerged) {
        mergedValues.push({ ...incomingValue });
      }
    });

    return {
      ...paymentItem,
      values: mergedValues,
    };
  });
};

export default mergePaymentMethods;
